import { z } from 'zod';
/**
 * إعدادات الذمم (debts.md section 21, customers.md section 10.1): one switch,
 * تأكيد رقم الهاتف برمز واتساب, off by default, read by the API on every
 * customer save. Viewing needs SETTINGS_VIEW, saving SETTINGS_UPDATE.
 */
export const debtsSettingsSchema = z.object({
    phoneVerificationEnabled: z.boolean(),
});
export const updateDebtsSettingsSchema = debtsSettingsSchema.strict();
//# sourceMappingURL=settings.js.map